module.exports = __webpack_public_path__ + "static/media/SEO_bg.54d9ab71.jpg";